import { queries } from "../../shared/queries";
import { useQuery } from "./useQuery";

// A tenant may register more than one custom domain; the earliest is canonical.
export function useTenantCustomDomain(): string | null {
  const [domains] = useQuery(queries.tenantCustomDomains());
  return domains?.[0]?.domain ?? null;
}
